class BeforeAfterSlider extends HTMLElement {
  constructor() {
    super();

    this.wrapper = this.querySelector(".before-after-slider__wrapper");
    this.before = this.querySelector(".before-after-slider__image--before");
    this.divider = this.querySelector(".before-after-slider__divider");
    this.handle = this.querySelector(".before-after-slider__handle");

    this.dragging = false;

    this.init();
  }

  init() {
    if (!this.wrapper) return;

    this.updatePosition(50);

    this.handle.addEventListener("mousedown", this.startDrag);
    this.wrapper.addEventListener("mousedown", this.startDrag);

    this.handle.addEventListener("touchstart", this.startDrag, {
      passive: true,
    });

    this.wrapper.addEventListener("touchstart", this.startDrag, {
      passive: true,
    });

    window.addEventListener("mousemove", this.onDrag);
    window.addEventListener("touchmove", this.onDrag, {
      passive: false,
    });

    window.addEventListener("mouseup", this.stopDrag);
    window.addEventListener("touchend", this.stopDrag);

    window.addEventListener("mouseleave", this.stopDrag);
  }

  startDrag = (event) => {
    this.dragging = true;
    this.move(event);
  };

  stopDrag = () => {
    this.dragging = false;
  };

  onDrag = (event) => {
    if (!this.dragging) return;

    event.preventDefault();

    this.move(event);
  };

  move(event) {
    const rect = this.wrapper.getBoundingClientRect();

    let clientX;

    if (event.touches) {
      clientX = event.touches[0].clientX;
    } else {
      clientX = event.clientX;
    }

    let percent = ((clientX - rect.left) / rect.width) * 100;

    percent = Math.max(0, Math.min(100, percent));

    this.updatePosition(percent);
  }

  updatePosition(percent) {
    this.before.style.clipPath = `inset(0 ${100 - percent}% 0 0)`;
    this.divider.style.left = `${percent}%`;
  }
}

customElements.define("before-after-slider", BeforeAfterSlider);